import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue'),
      meta: { title: '新闻资讯' }
    },
    {
      path: '/newsdetails/:id',
      name: 'newsdetails',
      component: () => import('./views/NewsDetails.vue'),
      meta: { title: '新闻详情' }
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue'),
      meta: { title: '产品中心' }
    },
    {
      path: '/productdetails/:id',
      name: 'productdetails',
      component: () => import('./views/ProductDetails.vue'),
      meta: { title: '产品详情' }
    },
    {
      path: '/case',
      name: 'case',
      component: () => import('./views/Case.vue'),
      meta: { title: '经典案例' }
    },
    {
      path: '/casedetails/:id',
      name: 'casedetails',
      component: () => import('./views/CaseDetails.vue'),
      meta: { title: '案例详情' }
    },
    {
      path: '/goin',
      name: 'goin',
      component: () => import('./views/GoIn.vue'),
      meta: { title: '关于我们' }
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('./views/Download.vue'),
      meta: { title: '联系我们' }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: { title: '登录', robots: 'noindex,nofollow' }
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {
        requireAuth: true
      },
      component: () => import('./views/Admin.vue'),
      redirect: '/admin/news',
      children: [{
          path: '/admin/user',
          name: 'user',
          component: () => import('./views/Admin/User.vue')
        },
        {
          path: '/admin/news',
          name: 'new',
          component: () => import('./views/Admin/News.vue')
        },
        {
          path: '/admin/cases',
          name: 'cases',
          component: () => import('./views/Admin/Cases.vue')
        },
        {
          path: '/admin/team',
          name: 'team',
          component: () => import('./views/Admin/Team.vue')
        },
        {
          path: '/admin/expert',
          name: 'expert',
          component: () => import('./views/Admin/Expert.vue')
        },
        {
          path: '/admin/course',
          name: 'course',
          component: () => import('./views/Admin/Course.vue')
        },
        {
          path: '/admin/enterprise',
          name: 'enterprise',
          component: () => import('./views/Admin/Enterprise.vue')
        },
        {
          path: '/admin/honor',
          name: 'honor',
          component: () => import('./views/Admin/Honor.vue')
        },
        {
          path: '/admin/product',
          name: 'adminProduct',
          component: () => import('./views/Admin/Products.vue')
        },
        {
          path: '/admin/dictionary',
          name: 'dictionary',
          component: () => import('./views/Admin/Dictionary.vue')
        },
        {
          path: '/admin/page',
          name: 'page',
          component: () => import('./views/Admin/Page.vue')
        }
      ]
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

// 切换路由时更新 document.title,提升 SEO
const SITE_NAME = '湖南中云图地理信息科技有限公司'
kejianrouter.afterEach((to) => {
  const sub = (to.meta && to.meta.title) ? `${to.meta.title}` : ''
  document.title = sub ? `${sub} - ${SITE_NAME}` : SITE_NAME
  // 后台/登录页 noindex
  const robots = (to.meta && to.meta.robots) ? to.meta.robots : ''
  let meta = document.querySelector('meta[name="robots"]')
  if (meta) {
    meta.setAttribute('content', robots || 'index,follow')
  }
})

export default kejianrouter